/* Règles du mot de passe client, communes à l'inscription et à la
   réinitialisation. */
export interface RegleMotDePasse { ok: boolean; libelle: string }

export function reglesMotDePasse(motDePasse: string): RegleMotDePasse[] {
  return [
    { ok: motDePasse.length >= 8,   libelle: '8 caractères minimum' },
    { ok: /[A-Z]/.test(motDePasse), libelle: 'une majuscule' },
    { ok: /[0-9]/.test(motDePasse), libelle: 'un chiffre' },
  ];
}

export const motDePasseConforme = (motDePasse: string) => reglesMotDePasse(motDePasse).every(r => r.ok);
